
/*
 TRINITY ARMAMENT
 NIGHT VISION MODE
 EASTER EGG #3
*/

document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "trinity-nvg-enabled";
  const root = document.documentElement;

  // Add visual effect layers
  const grain = document.createElement("div");
  grain.className = "trinity-nvg-grain";
  grain.setAttribute("aria-hidden", "true");

  const flash = document.createElement("div");
  flash.className = "trinity-nvg-flash";
  flash.setAttribute("aria-hidden", "true");

  document.body.appendChild(grain);
  document.body.appendChild(flash);

  let flashTimer;

  function updateButtons(enabled) {
    document.querySelectorAll("[data-trinity-nvg]")
      .forEach(button => {
        button.textContent = enabled
          ? "[ NVG // ON ]"
          : "[ NVG // OFF ]";

        button.setAttribute(
          "aria-pressed",
          String(enabled)
        );
      });
  }

  function setNightVision(enabled, animate = true) {
    root.classList.toggle("trinity-nvg-active", enabled);
    updateButtons(enabled);

    try {
      localStorage.setItem(
        STORAGE_KEY,
        enabled ? "true" : "false"
      );
    } catch (error) {
      // Mode still works if storage is unavailable.
    }

    if (animate && enabled) {
      clearTimeout(flashTimer);
      flash.classList.remove("active");

      // Restart flash animation
      void flash.offsetWidth;
      flash.classList.add("active");

      flashTimer = setTimeout(() => {
        flash.classList.remove("active");
      }, 650);
    }
  }

  let savedMode = false;

  try {
    savedMode = localStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    savedMode = false;
  }

  setNightVision(savedMode, false);

  document.addEventListener("click", event => {
    const button = event.target.closest("[data-trinity-nvg]");

    if (!button) return;

    event.preventDefault();

    const enabled = !root.classList.contains(
      "trinity-nvg-active"
    );

    setNightVision(enabled);
  });
});
